import { render, staticRenderFns } from "./receiveOrder.vue?vue&type=template&id=22b30772"
import script from "./receiveOrder.vue?vue&type=script&lang=js"
export * from "./receiveOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports